import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  select: {
    width: 100,
  },
  defaultSelect: {
    color: theme.palette.grey[700],
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  overFlowEllipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  progress: {
    width: 'inherit',
  },
  partNumber: {
    maxWidth: '100px',
  },
  downloadButton: {
    width: '0px',
    height: '100%',
  },
  delete: {
    padding: theme.spacing(1),
    margin: theme.spacing(0.7),
    stroke: theme.palette.grey[600],
    '&:hover': {
      stroke: theme.palette.grey[800],
    },
  },
  autoCompleteSelect: {
    width: 200,
  },
}));

export default useStyles;
